import { Skeleton, Box, Stack } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';

const PADDING = 2;

const FetchProgressBar = ({
  totalWidth,
  progressPercentage,
  processPercentageFont = 'body',
}: {
  progressPercentage: number;
  totalWidth: number;
  processPercentageFont?: 'body' | 'caption-medium';
}) => {
  const progressWidth = Math.round(progressPercentage * 0.01 * (totalWidth - 2 * PADDING));

  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent={'flex-end'} gap={1}>
        <Box
          sx={{
            position: 'relative',
            height: 3,
            width: totalWidth + 'px',
            borderRadius: '24px',
            backgroundColor: colors.grey[120],
          }}
        >
          <Skeleton
            variant="rounded"
            width={progressWidth}
            height={3}
            animation="wave"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              backgroundColor: colors.blue[500],
              border: 'none',
              ':after': {
                background:
                  'linear-gradient(90deg, transparent, rgba(255,255,255, 0.5), transparent)',
              },
            }}
          />
        </Box>
        <Typography variant={processPercentageFont}>{progressPercentage}%</Typography>
      </Stack>
    </Box>
  );
};

export default FetchProgressBar;
